import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OkPopupComponent } from 'src/app/shared/components/ok-popup/ok-popup.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-company-group-details',
  templateUrl: './company-group-details.component.html',
  styleUrls: ['./company-group-details.component.scss']
})
export class CompanyGroupDetailsComponent implements OnInit {

  @Input() companyGroupId?: number;

  newCompanyGroup: boolean = true;
  updatingGroup: boolean = false;

  companyGroupDetails = this.fb.group({
    id: [],
    name: [null, Validators.required],
    information: [],
    equityReleaseFee: [],
    accountName: [],
    accountNumber: [],
    sortCode: [],
    noAccessOrUpdatesForFAs: [false],
    adminEmailAddress: [null, Validators.email],
    managerEmailAddress: [null, Validators.email],
    apiAccess: [],
    apiClientId: [],
    apiClientSecret: [],
    active: [true],
    individualStatusId: new UntypedFormControl({ value: null, disabled: true })
  }, { });


  constructor(private fb: UntypedFormBuilder,
              public modalService: ModalService,
              private userService: UserService,
              private toastService: ToastService,
              public activeModal: NgbActiveModal) 
  {
  }

  ngOnInit(): void {

     if(this.companyGroupId !== undefined && this.companyGroupId !== null){
        this.newCompanyGroup = false;

        this.userService.companyGroupsDetails(this.companyGroupId).subscribe(result => {
          this.companyGroupDetails.patchValue(result);
          this.companyGroupDetails.markAllAsTouched();
        });
      }
      else {
        this.companyGroupDetails.markAllAsTouched();
      }
  }

  saveCompanyGroup(){

    this.updatingGroup = true;

    this.userService.updateCompanyGroup(this.companyGroupDetails.value).subscribe(response => {

      this.activeModal.close(true);
      this.updatingGroup = false;

      }, error => {

        var errorMessage = "Company Group Update Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.updatingGroup = false;
       this.toastService.error(errorMessage);


      });
  }

  addCompanyGroup(){
    this.userService.addCompanyGroup(this.companyGroupDetails.value).subscribe(response => {

      this.activeModal.close(true);

      }, error => {


        var errorMessage = "Company Group Creation Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.toastService.error(errorMessage);
    });
  }

  checkRestrictFAValue(){

    if(this.companyGroupDetails!.controls['noAccessOrUpdatesForFAs']!.value)
    {
       const modalRef = this.modalService.open(OkPopupComponent);
       modalRef.componentInstance.popupText1 = 'By clicking Yes, FAs from this company group will not be able to log in or receive update emails';
    }

  }

}
